
/* SOCALI Product Card Color Swatches */


/* SOCALI - Dawn Product Card Color Swatches */

document.addEventListener("click", function (event) {
  const swatch = event.target.closest(".socali-swatch");

  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest(".card-wrapper");

  if (!card) {
    console.warn("SOCALI: Product card not found");
    return;
  }

  const swatches = card.querySelectorAll(".socali-swatch");

  // 1. Update active color
  swatches.forEach((item) => {
    const active = item === swatch;

    item.classList.toggle("is-active", active);
    item.setAttribute("aria-pressed", String(active));
  });

  // 2. Get selected variant image
  const imageUrl = swatch.getAttribute("data-image");

  if (!imageUrl) {
    console.warn(
      "SOCALI: No variant image assigned",
      swatch.getAttribute("aria-label")
    );
    return;
  }

  // 3. Find the main product image
  const image = card.querySelector(
    ".card__inner .card__media .media img"
  );

  if (!image) {
    console.warn("SOCALI: Product image not found");
    return;
  }

  // 4. Update image
  image.removeAttribute("srcset");
  image.removeAttribute("sizes");

  image.src = imageUrl;

  image.alt =
    swatch.getAttribute("data-image-alt") ||
    swatch.getAttribute("aria-label") ||
    "";

  // 5. Disable secondary hover image
  card.classList.add("socali-image-selected");

  // 6. Update product links to selected variant
  const variantUrl = swatch.getAttribute("data-variant-url");

  if (variantUrl) {
    card.querySelectorAll(
      'a.full-unstyled-link[href*="/products/"]'
    ).forEach((link) => {
      link.href = variantUrl;
    });
  }
});
